import React, { useMemo, useState } from "react";
import * as Scrivito from "scrivito";
import { ProductReportsDownloadButtonsBlock } from "components";
import { items } from "variables";
import {
  useFetchScrivitoDocumentsForProduct,
  useTranslate,
  useUpdatedItemsForProductDownload,
} from "hooks";
import { ModalCheckboxesBlock } from "components/_Modals/ProjectDownloadModal/ModalCheckboxesBlock";
import { useProductConfiguratorStore } from "components/_ProductConfigurator/store/ProductConfiguratorStore";

export const ProductConfiguratorDownloads = Scrivito.connect(() => {
  const translate = useTranslate();
  const [itemsData, setItemsData] = useState(items);
  const [expandedAccordionIds, setExpandedAccordionIds] = useState([]);
  const productData = useProductConfiguratorStore.use.productData();
  const { seriesId } = useProductConfiguratorStore.use.requestParams() || {};
  const nodeId = useProductConfiguratorStore.use.nodeId();

  const { product } = productData || {};

  // TODO (25.11.25): LCA report can only be downloaded from SingleDownloadModal (should have nodeId)
  const filteredItems = useMemo(
    () => itemsData.filter((i) => i.id !== "LCA_REPORT"),
    [itemsData],
  );

  const { documents } = useFetchScrivitoDocumentsForProduct({
    seriesId,
  });

  useUpdatedItemsForProductDownload({
    documents,
    presentation: product?.orderCode?.presentation,
    setItemsData,
  });

  return (
    <div className="d-flex flex-column px-4 py-3 flex-grow-1 flex-shrink-2 bg-white rounded-2 gap-5">
      <h5>{translate("PRODUCT_CONFIGURATOR_DOWNLOADS")}</h5>
      <ModalCheckboxesBlock
        itemsData={filteredItems}
        setItemsData={setItemsData}
        blockTitle=""
        showProducts={false}
        seriesId={seriesId}
        expandedAccordionIds={expandedAccordionIds}
        setExpandedAccordionIds={setExpandedAccordionIds}
      />

      <ProductReportsDownloadButtonsBlock
        itemsData={filteredItems}
        setItemsData={setItemsData}
        documents={documents}
        productDataFromProductConfigurator={productData}
        requestParams={seriesId}
        orderCode={product?.orderCode}
        setExpandedAccordionIds={setExpandedAccordionIds}
        nodeId={nodeId}
      />
    </div>
  );
});
